//Tours
export const RECORRIDOS_RECIBIDOS = "RECORRIDOS_RECIBIDOS";
export const RECORRIDO_RECIBIDO = "RECORRIDO_RECIBIDO";
export const AGREGAR_RECORRIDO = "AGREGAR_RECORRIDO";
export const SET_PROPERTY_TOUR = "SET_PROPERTY_TOUR";
export const UPDATE_TOUR = "UPDATE_TOUR";
export const DELETE_TOUR = "DELETE_TOUR";
